/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentIdsForChat } from './DocumentIdsForChat';
import {
    DocumentIdsForChatFromJSON,
    DocumentIdsForChatFromJSONTyped,
    DocumentIdsForChatToJSON,
} from './DocumentIdsForChat';

/**
 * 
 * @export
 * @interface DocumentIdsChatResponse
 */
export interface DocumentIdsChatResponse {
    /**
     * 
     * @type {Array<DocumentIdsForChat>}
     * @memberof DocumentIdsChatResponse
     */
    documentIds: Array<DocumentIdsForChat>;
}

/**
 * Check if a given object implements the DocumentIdsChatResponse interface.
 */
export function instanceOfDocumentIdsChatResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentIds" in value;

    return isInstance;
}

export function DocumentIdsChatResponseFromJSON(json: any): DocumentIdsChatResponse {
    return DocumentIdsChatResponseFromJSONTyped(json, false);
}

export function DocumentIdsChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentIdsChatResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentIds': ((json['documentIds'] as Array<any>).map(DocumentIdsForChatFromJSON)),
    };
}

export function DocumentIdsChatResponseToJSON(value?: DocumentIdsChatResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentIds': ((value.documentIds as Array<any>).map(DocumentIdsForChatToJSON)),
    };
}

